module.exports = __webpack_public_path__ + "static/media/comic2009.mobile.cc87941b.png";